import { type IFirestoreModel } from '@principle-theorem/shared';
import { type IReportWidgetLayout } from './report-widget-layout';

export interface IReport extends IFirestoreModel {
  title: string;
  widgets: IReportWidgetLayout[];
}
